import { defu } from "defu";
import {
  useNuxtApp,
  useRequestEvent
} from "nuxt/app";
export function useSiteConfig(options) {
  let stack;
  if (import.meta.server)
    stack = useRequestEvent()?.context.siteConfig.get(defu({ resolveRefs: true }, options));
  else
    stack = useNuxtApp().$nuxtSiteConfig;
  return stack || {};
}
